// extracted by mini-css-extract-plugin
module.exports = {"light":"clinical-portal-3__AppointmentInvitesSummary__light"};